import styled from 'styled-components';
import { TextAlignProperty } from 'csstype';

import { theme } from '../../theme';
import { InputTypeEnum } from './input.types';

interface IStyledTextarea {
	placeholder: string;
	withLabel?: boolean;
	withDescription?: boolean;
	isDisabled?: boolean;
	hasError?: boolean;
	onSuccess?: boolean;
	width?: string;
	textAlign?: TextAlignProperty;
}

interface IStyledInput extends IStyledTextarea {
	type?: InputTypeEnum;
}

interface IStyledContainer {
	width?: string;
}

export const StyledContainer = styled.div`
	position: relative;
	display: inline-block;
	width: 100%;
`;

export const StyledErrorContainer = styled.div<IStyledContainer>`
	margin-top: 4px;
	max-width: ${({ width }) => width || `100%`};
	min-width: 96px;
	width: 100%;
`;

export const SytledLabelContainer = styled.div<IStyledContainer>`
	display: flex;
	justify-content: space-between;
	max-width: ${({ width }) => width || `100%`};
	min-width: 96px;
	width: 100%;
`;

export const StyledEyeIconContainer = styled.div`
	height: 16px;
	cursor: pointer;
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	right: 11px;
`;

const getBorderColor = (props: IStyledInput) => {
	if (props.isDisabled) {
		return theme.colors.input.border.disabled;
	}
	if (props.hasError) {
		return `${theme.colors.input.border.error} !important`;
	}
	if (props.onSuccess) {
		return theme.colors.input.border.success;
	}
	return theme.colors.input.border.default;
};

export const StyledInput = styled.input<IStyledInput>`
	position: relative;
	box-sizing: border-box;
	max-width: ${({ width }) => width || `100%`};
	min-width: 96px;
	width: 100%;
	height: 40px;
	border-radius: 4px;
	outline: none;
	font-size: 15px;
	font-family: 'ProximaNova-Medium';
	padding: 8px;
	color: ${({ isDisabled }) => (isDisabled ? theme.colors.input.text.disabled : theme.colors.input.text.default)};
	margin-top: ${({ withLabel }) => withLabel && '4px'};
	margin-bottom: ${({ withDescription }) => withDescription && '4px'};
	border: ${(props) => `1px solid ${getBorderColor(props)}`};
	background-color: ${({ isDisabled }) =>
		`${isDisabled ? theme.colors.input.background.disabled : theme.colors.input.background.default}`};
	::placeholder {
		color: ${({ isDisabled }) =>
			isDisabled ? theme.colors.input.placeholder.disabled : theme.colors.input.placeholder.default};
	}
	:focus {
		border-color: ${theme.colors.input.border.focus};
	}
	transition: border-color 300ms ease-in-out;
	text-align: ${({ textAlign }) => textAlign || 'initial'};
`;

export const StyledTextarea = styled.textarea<IStyledTextarea>`
	position: relative;
	box-sizing: border-box;
	max-width: ${({ width }) => width || `100%`};
	min-width: 96px;
	width: 100%;
	min-height: 104px;
	resize: vertical;
	border-radius: 4px;
	outline: none;
	font-size: 15px;
	font-family: 'ProximaNova-Medium';
	padding: 8px;
	color: ${theme.colors.input.text};
	margin-top: ${({ withLabel }) => withLabel && '4px'};
	margin-bottom: ${({ withDescription }) => withDescription && '4px'};
	border: ${(props) => `1px solid ${getBorderColor(props)}`};
	background-color: ${({ isDisabled }) =>
		isDisabled ? theme.colors.input.background.disabled : theme.colors.input.background.default};
	::placeholder {
		color: ${({ isDisabled }) =>
			isDisabled ? theme.colors.input.placeholder.disabled : theme.colors.input.placeholder.default};
	}
	:focus {
		border-color: ${theme.colors.input.border.focus};
	}
	transition: border-color 300ms ease-in-out;
	text-align: ${({ textAlign }) => textAlign || 'initial'};
`;
